import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps } from '../../redux/reducers';
import { refreshKey } from '../../redux/actionTypes/administration';
import { Grid, IconButton, Stack } from '@mui/material';
import PageHeaderComponent from '../common/components/pageHeader';
import { CustomButton } from '../common/components/customButton';
import DatePickerComponent from '../common/components/dateRangePicker';
import moment from 'moment';
import { CalculateUserTzToUTCTz, convertUTCDateToLocalDate, popUpAlert } from '../../utils/globalMethods';
import SearchComponent from '../common/components/searchComponent';
import * as actionTypes from "../../redux/actionTypes/csaSignup";
import { PropTypes } from "prop-types";
import TableComponent from '../common/components/table';
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import PartialSignupDetails from './partialSignupDetails';
import CommonLoading from '../common/components/commonLoading';


function createData(id,setId,vendorName,chosenNam,clientEmail,shareInfo,totalAmnt,createTs,phoneNumber,clientNam,lastUpdtTs,clientPreferdEmail,clientPreferdPhone, row) {
    return {
      id,
      setId,
      vendorName,
      chosenNam,
      clientEmail,
      shareInfo,
      totalAmnt,
      phoneNumber:phoneNumber,
      createTs:convertUTCDateToLocalDate(moment(createTs, "YYYY-MM-DDTHH:mm:ss[Z]").format('MM/DD/YYYY h:mm A')),
      clientNam:clientNam,
      lastUpdtTs:convertUTCDateToLocalDate(moment(lastUpdtTs, "YYYY-MM-DDTHH:mm:ss[Z]").format('MM/DD/YYYY h:mm A')),
      clientPreferdEmail,
      clientPreferdPhone,
      row
    };
  }
const PartialSignupComponent=(props) => {

  const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState();
    const [rows, setRows] = useState([]);
    const [size, setSize] = useState(10);
    const [from, setFrom] = useState(0);
     // eslint-disable-next-line no-unused-vars 
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [search, setSearch] = useState("");
    const [partialSignupTotal, setPartialSignupTotal] = useState(0);
    const [tableSort, setTableSort] = useState({"createTs":"DESC"});
    const [columns, setColumns] = useState([]);
    const [expand, setExpand] = useState(false);
     // eslint-disable-next-line no-unused-vars 
    const [onUpdate, setOnUpdate] = useState({});
    const [showLoader, setShowLoader] = useState(true);
    const [dateRangePickerLabel] = useState("Select Date");
    const [filterData, setFilterData] = useState({
      startDate: null,
      endDate: null,  
    });
    const [resetDate, setResetDate] = useState(false);


    const filterHandleChange = (date) => {
        setFilterData({
          ...filterData,
          endDate: date?.[0]?.endDate ? CalculateUserTzToUTCTz(date?.[0]?.endDate) : null,
          startDate:date?.[0]?.startDate ? CalculateUserTzToUTCTz(date?.[0]?.startDate) : null,
      });
    };

    useEffect(() => {      
      const userRole = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));
      if(props?.allowedRoles) {
        const checkRole = props?.allowedRoles.find((role) => userRole?.Role?.includes(role));
        if(!checkRole) {
          navigate('/dtahip');
          return;
        }
      }
      setOnUpdate({});
      setSelectedRows([]);
        const payload = {
          "nam": search?.trim(),
          "size": size,
          "from": from,
          "startDate": filterData.startDate ? moment(filterData.startDate.unix() * 1000).format("MM/DD/YYYY") : "",
          "endDate": filterData.endDate ? moment(filterData.endDate.unix() * 1000).format("MM/DD/YYYY") : "",
          "vendorNamSort":"vendorName" in tableSort ? tableSort["vendorName"]:"",
          "clientEmailSort":"clientEmail" in tableSort ? tableSort["clientEmail"]:"",
          // "shareNamSort":"shareInfo" in tableSort ? tableSort["shareInfo"]:"",
          "submittedDateSort":"createTs" in tableSort ? tableSort["createTs"]:"",
          "AmountSort":"totalAmnt" in tableSort ? tableSort["totalAmnt"]:"",
          "clientNameSort":"clientNam" in tableSort ? tableSort["clientNam"]:"",
        }
        props.getClientPartialSignupList(payload);
      }, [size,from,props.csaSignup.refreshKey,search,tableSort,filterData]);
     
      useEffect(() => {
        const { list, total, loading} = props.csaSignup.clientPartialSignupList;
        let data = [];
        setRows([]);
        setTimeout(()=>{
            list.forEach(element => {
            data.push(createData(element?.id,element?.setId,element?.vendorName,element?.chosenNam,element?.clientEmail,
              element?.shareInfo?.nam,element?.totalAmnt,element?.createTs,element?.phoneNumber,element?.clientNam,
              element?.lastUpdtTs,element?.clientPreferdEmail,element?.clientPreferdPhone,element
              ));
          });
          setRows(data);
          setPartialSignupTotal(total);
          setShowLoader(loading);  
        },300);
        handleColumns(); 
      
      }, [props?.csaSignup?.clientPartialSignupList]);
      
    const handleNext = (page, rowSize) => {
        (size != rowSize) && setSize(rowSize);
        setFrom(rowSize * page);
    }
    const handleSearch = (e) => {
      setSearch(e?.target?.value?.toLowerCase());
      setShowLoader(true);
      resetSize();
    }

    const resetSize= () =>{
      setFrom(0);
      setSize(10);
    }
      const handleDelete = (row) => { 
        const payload = {
          "setId": row?.setId,
          "clientId": row?.row?.clientId,
          "shareId": row?.row?.shareInfo?.id,
          "vendorId": row?.row?.vendorId,
          "agreementId" : row?.id,
        }
       props.deleteClientPartialSignupList(payload);

      }

      const handleOnDeleteAction = (row) => {
        popUpAlert({
          title: "Are you sure?",
          text: "Partial Signup will be removed from the application.",
          icon: "warning",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
          onConfirmed: true,
          handleConfirm:()=>handleDelete(row),
        });
      }

      const handleColumns = () => {
        const headers = [
            {id: 'details',label:'Details'},
            {id: 'vendorName',label:'Vendor Name',
            sort:"vendorName" in tableSort ? tableSort["vendorName"]:"",

          },
            {id: 'clientNam',label:'Client Name',
            sort:"clientNam" in tableSort ? tableSort["clientNam"]:"",
            cell: (item) => {
              const fullName = item?.clientNam ? item?.clientNam : '-';
              const nameArray = fullName.split(' ');
              const firstName = nameArray[0];
              return <>
                  <div>
                  {fullName}
                  </div>
              </>;
            }
          },
          {
            id: "chosenNam",
            label: "Preferred Name",
            cell:(item) =>{
              return item?.chosenNam ? item?.chosenNam : <div style={{paddingLeft:"35px"}}>{"-"}</div>
            }
          },
            {id: 'clientEmail',label:'Client Email',
            sort:"clientEmail" in tableSort ? tableSort["clientEmail"]:"",

          },
          //   {id: 'shareInfo',label:'Share Name',
          //   sort:"shareInfo" in tableSort ? tableSort["shareInfo"]:"",
          // },
            {id: 'totalAmnt',label:'Amount',            
            // sort:"totalAmnt" in tableSort ? tableSort["totalAmnt"]:"",
            cell:(item) => {
              return <div> {"$"+ item?.totalAmnt} </div> 
            }
          },
            {id: 'createTs',
              label:'Date of Signup',
              sort:"createTs" in tableSort ? tableSort["createTs"]:"",
              format: (value) => moment(value, "YYYY-MM-DDTHH:mm:ss[Z]").format('MM/DD/YYYY, h:mm a'),  
            },
            {
              id: 'action',
              label:'Action',
              cell: (item) => {
                return (<>
                  <IconButton aria-label="edit" onClick={() => {
                    // eslint-disable-next-line no-unused-vars
                    const { id, row, userAuth } = item;
                    const { clientId, vendorId } = row;
                    const userId = props?.userAuth?.user?.id
                    const url = `/dtafinder/csa-signup/${id}/${clientId}/${vendorId}?loginId=${userId}`;
                    // eslint-disable-next-line no-unused-vars
                    const state = {
                      vendorId: row?.vendorId,
                      agreementId: id,
                      clientId: row?.clientId,
                      loginId: userId
                    };
                  //  const url = ('/dtafinder/csa-signup/'+item?.id+'/'+item?.row?.clientId+'/'+item?.row?.vendorId+"?loginId="+props?.userAuth?.user?.id, {state:{vendorId: item?.row?.vendorId, agreementId: item?.id, clientId: item?.row?.clientId, loginId: props?.userAuth?.user?.id}}) ;
                   window.location.href = url;}
                  }>
                   <EditIcon />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleOnDeleteAction(item)} >
                    <DeleteIcon />
                  </IconButton>
                </>)
              }
            }
        ]
        setColumns(headers);
    }  

    const renderDetails = (row) => {
      return(
      <PartialSignupDetails
          row={row}
      />

      );
    };

     const handleSort = (item) => {
        let sortitem = {};
        if (item.sort == "" || item.sort == "DESC") {
          sortitem[item.id] = "ASC";
        } else {
          sortitem[item.id] = "DESC";
        }
        setTableSort(sortitem);
      };

  useEffect(() => {
    const {loading} = props?.csaSignup?.exportClientPartialSignup;
    setIsLoading(loading);
  },[props?.csaSignup?.exportClientPartialSignup?.exportClientPartialSignup]);

  const handleExport = () => {
    setIsLoading(true)
    const payload = {
      "nam": search?.trim(),
      "startDate": filterData.startDate ? moment(filterData.startDate.unix() * 1000).format("MM/DD/YYYY") : "",
      "endDate": filterData.endDate ? moment(filterData.endDate.unix() * 1000).format("MM/DD/YYYY") : "",
    }
    props.exportClientPartialSignup(payload);
  }
      
  return (
        <Grid container className="container-block" rowSpacing={2} >
          {isLoading && <CommonLoading />}
            <Grid item xs={12} md={6}>
                <PageHeaderComponent
                    title = {"PARTIAL SIGNUP "}
                    showSubtitle = {true}
                    subtitle = {"Total Records"}
                    count={partialSignupTotal}
                />
            </Grid>
            <Grid item xs={12}  md={6} sx={{ flexGrow: 1 }}>
                <Stack direction='row' spacing={2} justifyContent="flex-end">
                    <Grid item xs={6} md={3.5}>
                        <DatePickerComponent label ={dateRangePickerLabel}  selectedDateObj={(date) => { filterHandleChange(date, "", "date") }} 
                        resetDate={resetDate}
                        />
                    </Grid>
                    <Grid item>
                      <CustomButton variant="outlined"  startIcon={<i className="fa fa-download" aria-hidden="true"></i>} onClick={handleExport}>
                         Export
                      </CustomButton>
                    </Grid>
                    <Grid item>
                        <CustomButton variant="outlined" startIcon={<i className="fa fa-refresh" aria-hidden="true"></i>} onClick={()=>{
                       setSearch("");
                       setExpand(false);
                       props.refreshKey();
                       setFilterData('');
                       setTableSort({"createTs":"DESC"});
                       setResetDate(preDate=>
                        !preDate)
                       setShowLoader(true)}}>
                            Refresh  
                        </CustomButton>  
                    </Grid>          
                </Stack>
            </Grid>
            <Grid item xs={12} sx={{ flexGrow: 1 }}>
                <SearchComponent
                  placeholder={"Name,Email"}
                  handleChange={handleSearch}
                  searchText={search}
                />
            </Grid>
            <Grid item xs={12}>
                <TableComponent 
                  columns={columns}
                  rows={rows}
                  showDetails={true}
                  expand={expand}
                  renderDetails={renderDetails}
                  handlePagination={handleNext}
                  total={partialSignupTotal}
                  page={Math.floor(from / size)}
                  rowsPerPage={size}
                  handleSort={handleSort}
                  dataLoading={showLoader}
                />
            </Grid>

        </Grid>

    )
    
}
PartialSignupComponent.propTypes = {
    getClientPartialSignupList: PropTypes.func.isRequired,
    csaSignup: PropTypes.object.isRequired,
    showVendorHistoryDetails : PropTypes.bool,
    refreshKey:PropTypes.func.isRequired,
    exportClientPartialSignup: PropTypes.func.isRequired,
    deleteClientPartialSignupList:PropTypes.func.isRequired,
    id:PropTypes.object,
    userAuth: PropTypes.object.isRequired,
    allowedRoles: PropTypes.array,
}

function mapDispatchToProps(dispatch) {
    return {
        refreshKey: () => dispatch(refreshKey()),
        getClientPartialSignupList: (payload) =>dispatch(actionTypes.getClientPartialSignupList(payload)),
        exportClientPartialSignup : (payload) =>dispatch(actionTypes.exportClientPartialSignup(payload)),
        deleteClientPartialSignupList:(payload) =>dispatch(actionTypes.deleteClientPartialSignupList(payload))
      };
}

export default connect(mapStateToProps,mapDispatchToProps)(PartialSignupComponent);